// extracted by mini-css-extract-plugin
module.exports = {"merch_title":"lets-link-merch_merch_title__qiJ5g","merch_text":"lets-link-merch_merch_text__N_p8X","merch_inner":"lets-link-merch_merch_inner__FrXS0"};